export default __webpack_public_path__ + "static/media/in.5d3291b5.svg";